import React from "react";
import WaterSearchProvider from "./WaterSearchContext/provider";

const ContextProviders = ({ children }) => {
  return <WaterSearchProvider>{children}</WaterSearchProvider>;
};

export default ContextProviders;
